import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Popover } from 'antd';
import settings from 'settings';
import { Table } from 'components/Page';
import REDUCER_KEY from 'reducers/reducer.keys';
import NotificationIcon from './Icon';
import NotificationsWrapper from './Wrapper';
import config from './config';

const { NOTIFICATIONS_UPDATE_INTERVAL_MS, APP_CONFIG } = settings;
/**
 * @description Create an interval hook to keep state in scope
 * @param {callback} Function
 * @param {delay} Number
 * @triggers [{useEffect}, {useRef}]
 */
const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }

    return true;
  }, [delay]);
};

/**
 * @description Notifcation list and icon
 */
const Component = ({
  classes, count, icon, onAcknowledge, loadNotifications
}) => {
  // setup state hooks
  const [visible, setVisible] = useState(false);
  /**
   * @description Call acknowledge states update and reload on succesful
   * @triggers {onAcknowledge}
   */
  const handleAcknowledge = (id) => {
    const response = onAcknowledge(id);
    if (response) {
      response.then(() => loadNotifications());
    }
  };

  useEffect(() => {
    loadNotifications();
  }, []);

  // setup the interval hook
  useInterval(() => loadNotifications(), NOTIFICATIONS_UPDATE_INTERVAL_MS);
  return (
    <Popover
      content={(
        <Table
          pageSize={APP_CONFIG.defaultTablePageSmallSize}
          canAdmin
          classes="bhp-notifications-popup"
          config={{
            ...config,
            columns: [
              ...config.columns,
              {
                title: '',
                dataIndex: 'acknowledge',
                width: '40px',
                render: (text, record) => (
                  <Button
                    type="primary"
                    disabled={record.acknowledged_date}
                    icon="delete"
                    size="small"
                    onClick={() => handleAcknowledge(record.id)}
                  />
                )
              }
            ]
          }}
          reducer={{
            list: REDUCER_KEY.notifications,
            item: REDUCER_KEY.notification
          }}
        />
      )}
      placement="bottom"
      title="Notifications"
      trigger="click"
      visible={visible}
      onVisibleChange={setVisible}
    >
      <NotificationIcon active={visible} classes={classes} badgeCount={count} icon={icon} onClick={() => setVisible(!visible)} />
    </Popover>
  );
};

Component.propTypes = {
  classes: PropTypes.string,
  count: PropTypes.number,
  icon: PropTypes.string,
  onAcknowledge: PropTypes.func,
  loadNotifications: PropTypes.func
};

Component.defaultProps = {
  classes: '',
  count: 0,
  icon: 'bell',
  onAcknowledge() {
  },
  loadNotifications() {
  }
};

const Notifications = NotificationsWrapper(Component);

export default Notifications;
